module.exports = __webpack_public_path__ + "static/media/loiLogo.1d53feb9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/loiLogo.png
// module id = 922
// module chunks = 0